// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"13aedeb7","477":"612b822e"}[chunkId] + ".chunk.css";
};